import React, { useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import Pagination from '@mui/material/Pagination';
import classes from './styles.module.scss';
import DeleteConfirm from '../councellingStudentContainer/features/DeleteConfirm';
import { actionNotifier } from '../../components/ui/toast';

const formatDate = (value) => {
    if (!value) {
        return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '-';
    }

    return date.toLocaleString();
};

const SiteContactContainer = ({
    contactList,
    countPerPage,
    currentPage,
    onDeleteContact,
    onPageChange,
    refetchContactList,
    totalPages,
}) => {
    const [deleteId, setDeleteId] = useState(null);

    const handleConfirmDelete = async () => {
        if (!deleteId) {
            return;
        }

        try {
            await onDeleteContact(deleteId);
            setDeleteId(null);
        } catch (error) {
            actionNotifier.error(error?.data?.message || 'Unable to delete contact.');
        }
    };

    return (
        <div className={classes.contact_page_container}>
            <div className={classes.page_header}>
                <button
                    type="button"
                    className={classes.refresh_btn}
                    onClick={refetchContactList}
                >
                    <RefreshIcon fontSize="small" /> Refresh
                </button>
            </div>

            <div className={classes.contact_list_container}>
                {contactList.length > 0 ? (
                    <>
                        <div className={classes.table_wrapper}>
                            <table className={classes.contact_table}>
                                <thead>
                                    <tr>
                                        <th>SNo.</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Find Us</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contactList.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{(currentPage - 1) * countPerPage + index + 1}</td>
                                            <td>{item.name || '-'}</td>
                                            <td>{item.email || '-'}</td>
                                            <td>{item.phone || '-'}</td>
                                            <td>{item.findUs || '-'}</td>
                                            <td>{formatDate(item.createdAt)}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className={classes.delete_btn}
                                                    onClick={() => setDeleteId(item.id)}
                                                >
                                                    <DeleteOutlineIcon fontSize="small" /> Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {totalPages > 1 ? (
                            <div className={classes.pagination_container}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(_, page) => onPageChange(page)}
                                    color="primary"
                                    shape="rounded"
                                />
                            </div>
                        ) : null}
                    </>
                ) : (
                    <div className={classes.empty_state}>
                        No contact records found.
                    </div>
                )}
            </div>

            {deleteId !== null ? (
                <DeleteConfirm
                    isModalOpen={true}
                    handleModal={handleConfirmDelete}
                    setIsModalOpen={() => setDeleteId(null)}
                    title="Contact"
                />
            ) : null}
        </div>
    );
};

export default SiteContactContainer;
